import useQuery from '@shared/hooks/src/useQuery'
import { useMe } from '@shared/providers/src/MeProvider'
import { queryClient, setQueryData } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export default function useIndicator(type, query, options = {}) {
  const me = useMe()

  return useQuery({
    queryKey: QK.users.id(me.id).indicator(type).list(query),
    queryFn: () => API.users.id(me.id).indicators(type, query),
    enabled: Boolean(type),
    ...options,
  })
}

export const invalidateIndicator = (userId, type, query) => {
  return queryClient.invalidateQueries({ queryKey: QK.users.id(userId).indicator(type).list(query) })
}

export const updateIndicator = (userId, type, query, data) => {
  return setQueryData(QK.users.id(userId).indicator(type).list(query), data)
}

export const Indicator = {
  NeedReviewLabs: 'need_review_labs',
  HasOnDemandOrAsyncMessaging: 'has_on_demand_or_async_messaging',
  PendingHealthHistoryAlerts: 'pending_health_history_alerts',
  PendingAssessments: 'pending_health_assessments',
  UnreviewedLabs: 'unreviewed_labs',
  UnreadConversationsCount: 'unread_conversations_count',
  TotalUnreadMessageCount: 'total_unread_message_count',
}
